<template lang="pug">
  .auth--confirm
    form.auth__form(
      v-if="!success && !fails"
      @submit.prevent="loginUser")

      //- Email input
      input(
        type="email"
        name="email"
        v-model="email"
        v-validate="'required|email'"
        :data-vv-as="$t('auth.form.email')"
        :class="{'error': errors.has('email') }"
        :placeholder="$t('auth.form.email')")

      //- Password input
      Password(
        name="password"
        v-model="password"
        v-validate="'required'"
        :password="password"
        :data-vv-as="$t('auth.form.password')"
        :error="errors.has('password')")

      //- Form errors
      .margin-halve-top
        .auth__error(v-show="errors.has('name')") {{ errors.first('name') }}
        .auth__error(v-show="errors.has('lastName')") {{ errors.first('lastName') }}
        .auth__error(v-show="errors.has('email')") {{ errors.first('email') }}
        .auth__error(v-show="errors.has('password')") {{ errors.first('password') }}
        .auth__error(v-show="failsNotExist") {{ $t('errors.userNotExist.message')}}

      //- Submit button
      van-button(
        size="large"
        type="primary"
        native-type="submit") {{ $t('auth.form.send') }}

    //- Fails send email confirm
    .text--center(v-if="fails")
      van-icon(name="error")
      h1 {{ $t('errors.general.title')}}
      p {{ $t('errors.general.message')}}
</template>

<script>
import i18n from '@/locales/i18n';
import { mapGetters, mapActions } from 'vuex';
import UserService from '@/services/user.service';
import Password from '@/components/Password.vue';
import CryptoService from '@/services/crypto.service';
import { getErrorId } from '@/services/error.service';

export default {
  components: { Password },

  data() {
    return {
      email: '',
      password: '',
      success: false,
      fails: false,
      failsNotExist: false,
    };
  },

  computed: {
    ...mapGetters({
      appMode: 'globalModule/getAppMode',
    }),
  },

  methods: {
    ...mapActions({
      setAppModeStore: 'globalModule/setAppMode',
    }),

    /**
     * Compruebo si los datos del formulario son válidos
     */
    checkForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loginUser();
        }
      });
    },

    /*
     * Login user
     */
    async loginUser() {
      // Compruebo si hay una petición en curso,
      // si la hay, no hago nada
      if (this.isLoading) return;

      this.failsNotExist = false;

      this.$toast.loading({
        duration: 0,
        mask: true,
        message: i18n.t('general.loading'),
      });
      this.isLoading = true;

      // const data = {
      //   email: this.email,
      //   password: this.password,
      // };

      try {
        const user = await UserService.login(this.email, this.password);

        this.$toast.clear();
        this.isLoading = false;
        this.success = true;
        this.$emit('logged', user);
      } catch (error) {
        this.$toast.clear();
        this.isLoading = false;

        const authError = getErrorId(error);

        switch (authError) {
          case 'userNotConfirmed':
            // El usuario no ha validado su email, muestro una ventana preguntando
            // si quiere volver a recibir el email de validación.
            this.$dialog
              .confirm({
                title: i18n.t(`auth.messages.notValidate.title`),
                message: i18n.t(`auth.messages.notValidate.message`),
              })
              .then(() => this.sendConfirmEmail());
            break;
          case 'userNotExist':
            // El usuario no existe en la base de datos,
            // muestro un mensaje de error
            this.$toast.fail({
              mask: true,
              message: i18n.t('auth.messages.userNotExist'),
            });
            break;
          default:
            // Ocurrió cualquier otro error que impide al usuario loguearse
            this.$toast.fail({
              mask: true,
              message: i18n.t('general.errors.default.message'),
            });
            break;
        }
      }
    },

    /**
     * Vuelve a enviar el email de confirmación al usuario
     */
    async sendConfirmEmail() {
      try {
        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: i18n.t('general.loading'),
        });

        // Realizo la petición
        await UserService.sendConfirmEmail(this.email);

        // Quito el loader y Confirmo el envío del email
        this.$toast.clear();
        this.$toast.success({
          mask: true,
          message: i18n.t('auth.messages.resendToken'),
        });
      } catch (error) {
        // Ocurrió algún error,
        // quito el loader y muestro un mensaje de error
        this.$toast.clear();
        this.$toast.fail({
          mask: true,
          message: i18n.t('general.errors.default.message'),
        });
      }
    },

    /**
     * Obtiene el email y la contraseña del usuario si se había logueado previamente
     */
    getStoreData() {
      const userEmail = window.localStorage.getItem('userEmail');
      const userPassword = window.localStorage.getItem('userPassword');

      this.email = userEmail || '';
      this.password = userPassword ? CryptoService.decrypt(userPassword) : '';
    },
  },

  created() {
    this.getStoreData();
  },
};
</script>
